<template>
  <div
    class="box"
    :class="{ 'has-background-warning-light': highlighted }"
    :id="audio.guid"
  >
    <div class="level is-mobile">
      <div class="level-left">
        <p class="is-size-7 has-text-grey has-text-left">
          {{ new Date(audio.date) | formatDate }}
        </p>
      </div>
      <div class="level-right">
        <div
          v-if="audio.tutorLinks.length > 0"
          class="level-item"
          :title="sharedInfo"
        >
          <b-icon pack="fas" icon="user-friends" size="is-small" />
          <p class="pl-1 is-size-7">{{ audio.tutorLinks.length }}</p>
        </div>
        <div class="level-item">
          <b-button
            title="Share with tutors"
            @click="isShareModalActive = true"
          >
            <b-icon pack="fas" icon="share-alt" type="is-info" />
          </b-button>
        </div>
        <div class="level-item">
          <b-button title="Delete" :loading="deleting" @click="deleteRecording">
            <b-icon pack="fas" icon="trash-alt" type="is-danger" />
          </b-button>
        </div>
      </div>
    </div>
    <WaveformPlayer :src="audio.audioUrl" :from="0" text="Recorded" />
    <br />
    <WaveformPlayer
      :src="section.audioUrl"
      :from="audio.startTime"
      :to="audio.endTime"
      text="Original"
    />
    <br />
    <p class="is-size-7-mobile">{{ text }}</p>
    <br />
    <b-collapse
      v-if="tutorLinksWithResponse.length"
      :open="false"
      position="is-top"
    >
      <template #trigger="props">
        <div class="has-text-centered mb-3">
          <a>
            <b-icon :icon="!props.open ? 'caret-down' : 'caret-up'"></b-icon>
            {{ !props.open ? "See tutor response" : "Hide tutor response" }}
          </a>
        </div>
      </template>
      <div
        class="block has-background-light section"
        v-for="tutorLink in tutorLinksWithResponse"
        :key="tutorLink.tutor.tutorGuid"
      >
        <div class="columns is-vcentered">
          <div class="column is-10">
            <p class="has-text-weight-bold">{{ tutorLink.tutor.email }}</p>
            <p v-if="tutorLink.feedback" class="is-italic">
              {{ tutorLink.feedback }}
            </p>
          </div>
          <div class="column is-2">
            <b-icon
              v-if="tutorLink.praised"
              pack="fas"
              icon="star"
              type="is-warning"
              size="is-large"
            />
          </div>
        </div>
      </div>
    </b-collapse>
    <b-modal
      v-model="isShareModalActive"
      :destroy-on-hide="false"
      has-modal-card
    >
      <RecordingShare
        :sectionId="section.id"
        :recordingGuid="audio.guid"
        :tutorLinks="audio.tutorLinks"
      />
    </b-modal>
  </div>
</template>

<script>
import RecordingShare from "./RecordingShare";
import WaveformPlayer from "@/components/WaveformPlayer";
import filtersMixin from "@/mixins/filtersMixin";

export default {
  name: "Recording",
  mixins: [filtersMixin],
  props: ["section", "audio"],
  components: { WaveformPlayer, RecordingShare },
  computed: {
    sharedInfo() {
      if (this.audio.tutorLinks.length === 1) return `Shared with 1 tutor`;
      else return `Shared with ${this.audio.tutorLinks.length} tutors`;
    },
    text() {
      return this.audio.text ? this.audio.text : this.section.text;
    },
    tutorLinksWithResponse() {
      return this.audio.tutorLinks.filter(tl => tl.praised || tl.feedback);
    },
    highlighted() {
      return this.$route.query.recording === this.audio.guid;
    }
  },
  data() {
    return {
      deleting: false,
      isShareModalActive: false
    };
  },
  methods: {
    async deleteRecording() {
      this.deleting = true;
      this.$emit("deleted");
    }
  },
  mounted() {
    if (this.highlighted) {
      document.getElementById(this.audio.guid).scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped></style>
